import React, { useState, useEffect } from 'react';
import { external1, logo } from '../../assets/images';
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { getContactApiUrl } from '../../config/api';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IoChevronDownSharp, IoChevronUpSharp } from 'react-icons/io5';
import { MdOutlineChevronRight } from 'react-icons/md';
import { ImSearch } from 'react-icons/im';
import { trackGAEvent, GA_EVENTS } from '../../utils/googleAnalytics';

const Navbar = ({ blogSearchQuery, onBlogSearchChange }) => {
  const location = useLocation();
  const isBlogPage = location.pathname.startsWith('/blog');

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onChange",
  });

  const [showModal, setShowModal] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [showIndustriesDropdown, setShowIndustriesDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileServicesDropdown, setMobileServicesDropdown] = useState(false);
  const [mobileIndustriesDropdown, setMobileIndustriesDropdown] = useState(false);
  const [searchExpanded, setSearchExpanded] = useState(false);
  const [localSearchQuery, setLocalSearchQuery] = useState('');

  useEffect(() => {
    if (blogSearchQuery !== undefined) {
      setLocalSearchQuery(blogSearchQuery);
    }
  }, [blogSearchQuery]);

  useEffect(() => {
    if (!isBlogPage) {
      setSearchExpanded(false);
      setLocalSearchQuery('');
    }
  }, [isBlogPage]);

  const handleClose = () => {
    setShowModal(false);
    setIsSubmitted(false);
    setSubmitStatus(null);
  };

  const handleShow = () => setShowModal(true);

  const handleSearchToggle = () => {
    setSearchExpanded(!searchExpanded);
    if (searchExpanded && localSearchQuery) {
      setLocalSearchQuery('');
      if (onBlogSearchChange) {
        onBlogSearchChange('');
      }
    }
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setLocalSearchQuery(value);
    if (onBlogSearchChange) {
      onBlogSearchChange(value);
    }
  };

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await axios.post(getContactApiUrl(), {
        fullName: data.fullName,
        email: data.email,
        cellPhone: data.cellPhone,
        message: data.message,
      });

      if (response.data.success) {
        setSubmitStatus('success');
        setIsSubmitted(true);
        reset();
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Mobile Navigation */}
      <div className="d-block d-lg-none">
        <div
          className={`mobile-navbar-overlay ${mobileMenuOpen ? 'show' : ''}`}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100vh',
            backgroundColor: '#000',
            zIndex: 9999,
            transform: mobileMenuOpen ? 'translateY(0)' : 'translateY(-100%)',
            transition: 'transform 0.3s ease-in-out'
          }}
        >
          <div
            className="mobile-menu-content"
            style={{
              width: '100%',
              height: '100%',
              backgroundColor: '#000',
              color: '#fff',
              padding: '20px',
              overflowY: 'auto',
              paddingTop: '60px'
            }}
          >
            <div className="d-flex justify-content-end mb-4" style={{ position: 'absolute', top: '10px', right: '20px' }}>
              <span
                onClick={() => setMobileMenuOpen(false)}
                style={{
                  cursor: 'pointer',
                  fontSize: '22px',
                  color: '#fff'
                }}
              >
                <FaTimes />
              </span>
            </div>
            <div className="mobile-menu-items">
               <Link
                to="/"
                onClick={() => {
                  setMobileMenuOpen(false);
                  trackGAEvent(GA_EVENTS.HEADER_HOME, 'Navigation', 'Mobile Menu');
                }}
                className="d-block py-3 text-decoration-none"
                style={{ color: '#fff', fontSize: '15px', borderBottom: '1px solid #333' }}
              >
                Home
              </Link>
              <div className="mb-0">
                <div
                  className="d-flex align-items-center justify-content-between py-3"
                  onClick={() => setMobileIndustriesDropdown(!mobileIndustriesDropdown)}
                  style={{ cursor: 'pointer', borderBottom: '1px solid #333' }}
                >
                  <span style={{ color: '#fff', fontSize: '15px' }}>What we do <MdOutlineChevronRight className='fs-5' />
                  </span>
                  <i className={`fa ${mobileIndustriesDropdown ? 'fa-angle-down' : 'fa-angle-right'} text-white`}></i>
                </div>
                {mobileIndustriesDropdown && (
                  <div className="ps-3 mt-2">
                     <Link
                      to="/industries/credentialing"
                      onClick={() => setMobileMenuOpen(false)}
                      className="d-block py-2 text-decoration-none"
                      style={{ color: '#ccc', fontSize: '13px' }}
                    >
                      <i className="fa fa-arrow-right me-2"></i>
                        Credentialing
                    </Link>
                    <Link
                      to="/industries/accounts-receivable"
                      onClick={() => setMobileMenuOpen(false)}
                      className="d-block py-2 text-decoration-none"
                      style={{ color: '#ccc', fontSize: '13px' }}
                    >
                      <i className="fa fa-arrow-right me-2"></i>
                      Accounts Receivable
                    </Link>
                    <Link
                      to="/industries/denial-management"
                      onClick={() => setMobileMenuOpen(false)}
                      className="d-block py-2 text-decoration-none"
                      style={{ color: '#ccc', fontSize: '13px' }}
                    >
                      <i className="fa fa-arrow-right me-2"></i>
                      Denial Management Services
                    </Link>
                    <Link
                      to="/industries/charge-entry-audit"
                      onClick={() => setMobileMenuOpen(false)}
                      className="d-block py-2 text-decoration-none"
                      style={{ color: '#ccc', fontSize: '13px' }}
                    >
                      <i className="fa fa-arrow-right me-2"></i>
                      Charge Entry & Audit
                    </Link>
                    <Link
                      to="/industries/account-reconciliation"
                      onClick={() => setMobileMenuOpen(false)}
                      className="d-block py-2 text-decoration-none"
                      style={{ color: '#ccc', fontSize: '13px' }}
                    >
                      <i className="fa fa-arrow-right me-2"></i>
                      Account Reconciliation
                    </Link>
                    <Link
                      to="/industries/payment-posting"
                      onClick={() => setMobileMenuOpen(false)}
                      className="d-block py-2 text-decoration-none"
                      style={{ color: '#ccc', fontSize: '13px' }}
                    >
                      <i className="fa fa-arrow-right me-2"></i>
                       Payment Posting
                    </Link>
                   
                  </div>
                )}
              </div>
              <div className="mb-0">
                <div
                  className="d-flex align-items-center justify-content-between py-3"
                  onClick={() => setMobileServicesDropdown(!mobileServicesDropdown)}
                  style={{ cursor: 'pointer', borderBottom: '1px solid #333' }}
                >
                  <span style={{ color: '#fff', fontSize: '15px' }}>Who we help <MdOutlineChevronRight className='fs-5' /></span>
                  <i className={`fa ${mobileServicesDropdown ? 'fa-angle-down' : 'fa-angle-right'} text-white`}></i>
                </div>
                {mobileServicesDropdown && (
                  <div className="ps-3 mt-2">
                    <Link
                      to="/services/nurse-practitioners"
                      onClick={() => {
                        setMobileMenuOpen(false);
                        trackGAEvent(GA_EVENTS.INDUSTRY_NURSE_PRACTITIONERS, 'Navigation', 'Mobile Dropdown');
                      }}
                      className="d-block py-2 text-decoration-none"
                      style={{ color: '#ccc', fontSize: '13px' }}
                    >
                      <i className="fa fa-arrow-right me-2"></i>
                      Nurse Practitioners
                    </Link>
                    <Link
                      to="/services/mental-health"
                      onClick={() => {
                        setMobileMenuOpen(false);
                        trackGAEvent(GA_EVENTS.INDUSTRY_MENTAL_HEALTH, 'Navigation', 'Mobile Dropdown');
                      }}
                      className="d-block py-2 text-decoration-none"
                      style={{ color: '#ccc', fontSize: '13px' }}
                    >
                      <i className="fa fa-arrow-right me-2"></i>
                      Mental Health
                    </Link>
                    <Link
                      to="/services/chiro"
                      onClick={() => {
                        setMobileMenuOpen(false);
                        trackGAEvent(GA_EVENTS.INDUSTRY_CHIRO, 'Navigation', 'Mobile Dropdown');
                      }}
                      className="d-block py-2 text-decoration-none"
                      style={{ color: '#ccc', fontSize: '13px' }}
                    >
                      <i className="fa fa-arrow-right me-2"></i>
                      Chiro
                    </Link>
                    <Link
                      to="/services/family-medicine"
                      onClick={() => {
                        setMobileMenuOpen(false);
                        trackGAEvent(GA_EVENTS.INDUSTRY_FAMILY_MEDICINE, 'Navigation', 'Mobile Dropdown');
                      }}
                      className="d-block py-2 text-decoration-none"
                      style={{ color: '#ccc', fontSize: '13px' }}
                    >
                      <i className="fa fa-arrow-right me-2"></i>
                      Family Medicine
                    </Link>
                    <Link
                      to="/services/internal-medicine"
                      onClick={() => {
                        setMobileMenuOpen(false);
                        trackGAEvent(GA_EVENTS.INDUSTRY_INTERNAL_MEDICINE, 'Navigation', 'Mobile Dropdown');
                      }}
                      className="d-block py-2 text-decoration-none"
                      style={{ color: '#ccc', fontSize: '13px' }}
                    >
                      <i className="fa fa-arrow-right me-2"></i>
                      Internal Medicine
                    </Link>
                    <Link
                      to="/services/pt"
                      onClick={() => {
                        setMobileMenuOpen(false);
                        trackGAEvent(GA_EVENTS.INDUSTRY_PT, 'Navigation', 'Mobile Dropdown');
                      }}
                      className="d-block py-2 text-decoration-none"
                      style={{ color: '#ccc', fontSize: '13px' }}
                    >
                      <i className="fa fa-arrow-right me-2"></i>
                      PT
                    </Link>
                  </div>
                )}
              </div>
              <Link
                to="/about"
                onClick={() => {
                  setMobileMenuOpen(false);
                  trackGAEvent(GA_EVENTS.HEADER_ABOUT, 'Navigation', 'Mobile Menu');
                }}
                className="d-block py-3 text-decoration-none"
                style={{ color: '#fff', fontSize: '15px', borderBottom: '1px solid #333' }}
              >
                About Us
              </Link>

              <Link
                to="/blog"
                onClick={() => {
                  setMobileMenuOpen(false);
                  trackGAEvent(GA_EVENTS.HEADER_BLOG, 'Navigation', 'Mobile Menu');
                }}
                className="d-block py-3 text-decoration-none"
                style={{ color: '#fff', fontSize: '15px', borderBottom: '1px solid #333' }}
              >
                Blogs
              </Link>

              <Link
                to="/contact"
                onClick={() => {
                  setMobileMenuOpen(false);
                  trackGAEvent(GA_EVENTS.HEADER_CONTACT, 'Navigation', 'Mobile Menu');
                }}
                className="d-block py-3 text-decoration-none"
                style={{ color: '#fff', fontSize: '15px' }}
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Navigation */}
      <div className="container-fluid">
        <div className="row mx-auto header-bg-nav">
          <div className="col-12 px-lg-5">
            <nav
              className="w-100 navbar navbar-expand-lg navbar-light fixed-top m-0 px-md-5 px-0"
              style={{
                backgroundColor: '#F6F6F6',
              }}
            >
              <div className="container-fluid mx-lg-5 p-lg-3"
                style={{
                  backgroundColor: '#F6F6F6',
                  borderRadius: "20px",
                }}>
                <a className="navbar-brand ps-lg-5" href="/">
                  <img src={logo} className="img-fluid navbar-logo" alt="logo" />
                </a>

                {/* Mobile Toggle Button */}
                <button
                  className="navbar-toggler border-0 d-lg-none p-0 m-0"
                  type="button"
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  aria-label="Toggle navigation"
                >
                  {mobileMenuOpen ? <FaTimes /> : <FaBars />}
                </button>

                {/* Desktop Menu */}
                <div className="collapse navbar-collapse w-100 ps-lg-5 d-none d-lg-block">
                  <ul className="navbar-nav mx-auto mb-2 mb-lg-0 ps-lg-5">
                    <li
                      className="nav-item dropdown"
                      onMouseEnter={() => setShowIndustriesDropdown(true)}
                      onMouseLeave={() => setShowIndustriesDropdown(false)}
                    >
                      <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        role="button"
                        aria-expanded={showIndustriesDropdown}
                      >
                        What we do
                        <i style={{ marginLeft: '5px', fontWeight: 'bold' }}>
                          {showIndustriesDropdown ? <IoChevronUpSharp /> : <IoChevronDownSharp />}
                        </i>
                      </a>

                      <ul className={`custom-dropdown-menu py-3 ${showIndustriesDropdown ? 'show' : ''}`}>
                        <div className="row">
                          <div className="col-12 px-0">
                            <li>
                              <Link 
                                className="dropdown-item px-0" 
                                to="/industries/credentialing"
                                onClick={() => trackGAEvent(GA_EVENTS.SERVICE_CREDENTIALING, 'Navigation', 'Desktop Dropdown')}
                              >
                                Credentialing
                              </Link>
                            </li>
                          </div>
                          <div className="col-12 px-0">
                            <li>
                              <Link 
                                className="dropdown-item px-0" 
                                to="/industries/accounts-receivable"
                                onClick={() => trackGAEvent(GA_EVENTS.SERVICE_ACCOUNTS_RECEIVABLE, 'Navigation', 'Desktop Dropdown')}
                              >
                                Accounts Receivable
                              </Link>
                            </li>
                          </div>
                          <div className="col-12 px-0">
                            <li>
                              <Link 
                                className="dropdown-item px-0" 
                                to="/industries/denial-management"
                                onClick={() => trackGAEvent(GA_EVENTS.SERVICE_DENIAL_MANAGEMENT, 'Navigation', 'Desktop Dropdown')}
                              >
                                Denial Management Services
                              </Link>
                            </li>
                          </div>
                          <div className="col-12 px-0">
                            <li>
                              <Link 
                                className="dropdown-item px-0" 
                                to="/industries/charge-entry-audit"
                                onClick={() => trackGAEvent(GA_EVENTS.SERVICE_CHARGE_ENTRY_AUDIT, 'Navigation', 'Desktop Dropdown')}
                              >
                                Charge Entry & Audit
                              </Link>
                            </li>
                          </div>
                          <div className="col-12 px-0">
                            <li>
                              <Link 
                                className="dropdown-item px-0" 
                                to="/industries/account-reconciliation"
                                onClick={() => trackGAEvent(GA_EVENTS.SERVICE_ACCOUNT_RECONCILIATION, 'Navigation', 'Desktop Dropdown')}
                              >
                                Account Reconciliation
                              </Link>
                            </li>
                          </div>
                          <div className="col-12 px-0">
                            <li>
                              <Link 
                                className="dropdown-item px-0" 
                                to="/industries/payment-posting"
                                onClick={() => trackGAEvent(GA_EVENTS.SERVICE_PAYMENT_POSTING, 'Navigation', 'Desktop Dropdown')}
                              >
                                Payment Posting
                              </Link>
                            </li>
                          </div>
                          
                        </div>
                      </ul>
                    </li>

                    <li className="nav-item dropdown"
                      onMouseEnter={() => setShowServicesDropdown(true)}
                      onMouseLeave={() => setShowServicesDropdown(false)}>
                      <a className="nav-link dropdown-toggle" href="#" role="button"
                        aria-expanded={showServicesDropdown}>
                        Who we help <i style={{ marginLeft: '5px', fontWeight: "bold" }}>
                          {showServicesDropdown ? <IoChevronUpSharp /> : <IoChevronDownSharp />}
                        </i>
                      </a>
                      <ul className={`custom-dropdown-menu py-3 ${showServicesDropdown ? 'show' : ''}`}>
                        <div className='row'>
                          <div className='col-12 px-0'>
                            <li>
                              <Link 
                                className="dropdown-item fw-bold" 
                                to="/services/nurse-practitioners"
                                onClick={() => trackGAEvent(GA_EVENTS.INDUSTRY_NURSE_PRACTITIONERS, 'Navigation', 'Desktop Dropdown')}
                              >
                                Nurse Practitioners
                              </Link>
                            </li>
                          </div>
                          <div className='col-12 px-0'>
                            <li>
                              <Link 
                                className="dropdown-item fw-bold" 
                                to="/services/mental-health"
                                onClick={() => trackGAEvent(GA_EVENTS.INDUSTRY_MENTAL_HEALTH, 'Navigation', 'Desktop Dropdown')}
                              >
                                Mental Health
                              </Link>
                            </li>
                          </div>
                          <div className='col-12 px-0'>
                            <li>
                              <Link 
                                className="dropdown-item fw-bold" 
                                to="/services/chiro"
                                onClick={() => trackGAEvent(GA_EVENTS.INDUSTRY_CHIRO, 'Navigation', 'Desktop Dropdown')}
                              >
                                Chiro
                              </Link>
                            </li>
                          </div>
                          <div className='col-12 px-0'>
                            <li>
                              <Link 
                                className="dropdown-item fw-bold" 
                                to="/services/family-medicine"
                                onClick={() => trackGAEvent(GA_EVENTS.INDUSTRY_FAMILY_MEDICINE, 'Navigation', 'Desktop Dropdown')}
                              >
                                Family Medicine
                              </Link>
                            </li>
                          </div>
                          <div className='col-12 px-0'>
                            <li>
                              <Link 
                                className="dropdown-item fw-bold" 
                                to="/services/internal-medicine"
                                onClick={() => trackGAEvent(GA_EVENTS.INDUSTRY_INTERNAL_MEDICINE, 'Navigation', 'Desktop Dropdown')}
                              >
                                Internal Medicine
                              </Link>
                            </li>
                          </div>
                          <div className='col-12 px-0'>
                            <li>
                              <Link 
                                className="dropdown-item fw-bold" 
                                to="/services/pt"
                                onClick={() => trackGAEvent(GA_EVENTS.INDUSTRY_PT, 'Navigation', 'Desktop Dropdown')}
                              >
                                PT
                              </Link>
                            </li>
                          </div>
                        </div>
                      </ul>
                    </li>
                    <li className="nav-item">
                      <Link 
                        className="nav-link" 
                        to="/about"
                        onClick={() => trackGAEvent(GA_EVENTS.HEADER_ABOUT, 'Navigation', 'Desktop Menu')}
                      >
                        About
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link 
                        className="nav-link" 
                        to="/blog"
                        onClick={() => trackGAEvent(GA_EVENTS.HEADER_BLOG, 'Navigation', 'Desktop Menu')}
                      >
                        Blogs
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link 
                        className="nav-link" 
                        to="/contact"
                        onClick={() => trackGAEvent(GA_EVENTS.HEADER_CONTACT, 'Navigation', 'Desktop Menu')}
                      >
                        Contact Us
                      </Link>
                    </li>
                  </ul>

                  <div className="nav-icons flex-grow-2 d-flex align-items-center ms-md-auto pe-md-5" style={{ gap: '12px' }}>
                    {/* Expandable Search for Blog Page */}
                    {isBlogPage && (
                      <div
                        style={{
                          position: 'relative',
                          display: 'flex',
                          alignItems: 'center',
                          overflow: 'hidden'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: searchExpanded ? '250px' : '40px',
                            transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                            position: 'relative'
                          }}
                        >
                          <input
                            type="text"
                            placeholder="Search blogs..."
                            value={localSearchQuery}
                            onChange={handleSearchInputChange}
                            style={{
                              width: '100%',
                              height: '40px',
                              paddingLeft: '40px',
                              paddingRight: '12px',
                              border: '2px solid #e9ecef',
                              borderRadius: '20px',
                              fontSize: '14px',
                              outline: 'none',
                              opacity: searchExpanded ? 1 : 0,
                              transition: 'opacity 0.3s ease',
                              pointerEvents: searchExpanded ? 'auto' : 'none',
                              backgroundColor: 'white'
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#F37016';
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#e9ecef';
                            }}
                          />
                          <button
                            onClick={handleSearchToggle}
                            style={{
                              position: 'absolute',
                              left: 0,
                              width: '40px',
                              height: '40px',
                              border: 'none',
                              borderRadius: '50%',
                              backgroundColor: searchExpanded ? 'transparent' : '#F37016',
                              color: searchExpanded ? '#6c757d' : 'white',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.3s ease',
                              zIndex: 1
                            }}
                            onMouseEnter={(e) => {
                              if (!searchExpanded) {
                                e.currentTarget.style.backgroundColor = '#B1510F';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!searchExpanded) {
                                e.currentTarget.style.backgroundColor = '#F37016';
                              }
                            }}
                          >
                            <ImSearch size={16} />
                          </button>
                          {searchExpanded && localSearchQuery && (
                            <button
                              onClick={() => {
                                setLocalSearchQuery('');
                                if (onBlogSearchChange) {
                                  onBlogSearchChange('');
                                }
                              }}
                              style={{
                                position: 'absolute',
                                right: '8px',
                                width: '24px',
                                height: '24px',
                                border: 'none',
                                borderRadius: '50%',
                                backgroundColor: 'transparent',
                                color: '#6c757d',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '18px',
                                padding: 0
                              }}
                            >
                              ×
                            </button>
                          )}
                        </div>
                      </div>
                    )}

                    <button
                      className="btn liquid-btn border-0"
                      onClick={() => {
                        handleShow();
                        trackGAEvent(GA_EVENTS.HEADER_LETS_CONNECT, 'CTA', 'Header Button');
                      }}
                    >
                      <span>Let's Connect</span>
                      <div className="liquid"></div>
                    </button>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>

      {/* Contact Modal */}
      <Modal show={showModal} onHide={handleClose} centered size='xl'>
        <button
          type="button"
          className="btn-close position-absolute"
          style={{
            top: "11px",
            right: "11px",
            zIndex: 1051,
            backgroundColor: "#fff",
            borderRadius: "50%",
            padding: "6px",
            fontSize: "15px",
            // border: "2px solid black",
          }}
          aria-label="Close"
          onClick={handleClose}
        ></button>

        <Modal.Body className="p-4">
          <div className="container-fluid">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-lg-6 d-none d-lg-block">
                <div className="image-container">
                  <img
                    src={external1}
                    alt="Team Working"
                    className="w-100 h-100 diagonal-image"
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 ps-md-4 ps-0">
                {isSubmitted ? (
                  <div className="text-center">
                    <h1 className="hero-text mt-0">
                      Thank <span className="text-orange add_grident_font" style={{ color: "#E9720E" }}>You!</span>
                    </h1>
                    <p>for submitting your information! Our representative will reach out to you shortly.</p>
                  </div>
                ) : (
                  <>
                    <div className="d-flex m-0 modal-heading justify-content-between">
                      <h1>
                        How can we <span style={{ color: "#E27239" }}>help you?</span>
                      </h1>
                    </div>
                    <p className="fs-6 m-0 d-lg-none" style={{ color: "#2A3040" }}>
                      Within 24 hours, a representative from our company will contact you.
                    </p>
                    <form onSubmit={handleSubmit(onSubmit)} className="mt-0">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label fw-medium text-start d-block">Name</label>
                          <input
                            type="text"
                            placeholder="Enter your Full Name"
                            className={`custom_control py-2 form-control ${errors.fullName ? "is-invalid" : ""}`}
                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                            {...register("fullName", { required: "Full Name is required" })}
                          />
                          {errors.fullName && (
                            <p className="text-danger">{errors.fullName.message}</p>
                          )}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="form-label fw-medium text-start d-block">Email</label>
                          <input
                            type="email"
                            placeholder="Enter your Email"
                            className={`custom_control py-2 form-control ${errors.email ? "is-invalid" : ""}`}
                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: "Invalid email address"
                              }
                            })}
                          />
                          {errors.email && (
                            <p className="text-danger">{errors.email.message}</p>
                          )}
                        </div>

                        <div className="col-md-12 mb-3">
                          <label className="form-label fw-medium text-start d-block">Phone Number</label>
                          <input
                            type="tel"
                            placeholder="Enter your Phone Number"
                            className={`custom_control py-2 form-control ${errors.cellPhone ? "is-invalid" : ""}`}
                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                            {...register("cellPhone", { required: "Phone number is required" })}
                          />
                          {errors.cellPhone && (
                            <p className="text-danger">{errors.cellPhone.message}</p>
                          )}
                        </div>

                        <div className="col-md-12 mb-3">
                          <label className="form-label fw-medium text-start d-block">Message</label>
                          <textarea
                            placeholder="Enter your Message"
                            className={`custom_control py-2 form-control ${errors.message ? "is-invalid" : ""}`}
                            style={{ border: "1px solid #A4A4A480", minHeight: "100px" }}
                            {...register("message", { required: "Message is required" })}
                          ></textarea>
                          {errors.message && (
                            <p className="text-danger">{errors.message.message}</p>
                          )}
                        </div>
                      </div>

                      {submitStatus === 'error' && (
                        <div className="alert alert-danger" role="alert">
                          There was an error sending your message. Please try again.
                        </div>
                      )}

                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={isSubmitting}
                        style={{ height: "48px", backgroundColor: "#E27239", border: "none" }}
                        onClick={() => trackGAEvent(GA_EVENTS.FORM_SUBMIT_HEADER, 'Form', 'Header Modal')}
                      >
                        {isSubmitting ? 'Sending...' : 'Send Message'}
                      </button>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Navbar;